var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-input"},[_c('input',_vm._g(_vm._b({class:['input', 'has-text-centered', { 'is-danger': _vm.error } ],attrs:{"type":"number","min":"0"}},'input',_vm.attrs,false),_vm.listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }